<template>
    <be-modal with-header with-footer effect="1" :full-color="color" :show="!!route">
        <div class="text-center"><span :class="`modal-main-icon mdi ${icon}`"></span>
            <slot>
                <h3>{{title}}</h3>
                <p>{{description}}</p>
            </slot>
            <div class="mt-8">
                <button class="btn btn-secondary btn-space" type="button" @click="next">Fortsetzen</button>
                <button class="btn btn-success btn-space" type="button" @click="cancel">Abbrechen</button>
            </div>
        </div>
    </be-modal>
</template>

<script>
    export default {
        props: {
            route: {
                type: Function,
            },
            color: {
                type: String,
                default: 'danger',
            },
            icon: {
                type: String,
                default: 'mdi-close-circle-o',
            },
            title: String,
            description: String,
        },

        methods: {
            next() {
                this.route();
                this.$emit('update:route', null);
            },

            cancel() {
                this.route(false);
                this.$emit('update:route', null);
            },
        },
    };
</script>
